export default {
  BASE_URL: '/area/china',
  api: [
    {
      name: 'levelOne',
      desc: '获取省级地区',
      method: 'GET',
      path: '/selectByAreaLevel/1'
    },
    {
      name: 'update',
      desc: '获取市级地区',
      method: 'GET',
      path: '/selectByAreaLevel/2'
    },
    {
      name: 'selectTwoLevelForCascader',
      desc: '获取省级市级联级数据',
      method: 'GET',
      path: '/selectTwoLevelForCascader'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/area/index.js